import { render } from "./Upload.vue?vue&type=template&id=beee9a96&scoped=true"
import script from "./Upload.vue?vue&type=script&lang=ts"
export * from "./Upload.vue?vue&type=script&lang=ts"

import "./Upload.vue?vue&type=style&index=0&id=beee9a96&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-beee9a96"

export default script